import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React, { useMemo } from 'react';

import { DropdownProps } from './Dropdown.types';

const Dropdown: React.FC<DropdownProps> = ({
  options,
  value,
  onChange,
  style,
  placeHolder = 'Choose an option',
  label,
  sx,
  multiple = false,
  id = 'simple-select-label',
  ...rest
}) => {
  const selectedValue = multiple
    ? value ||
      [].filter(
        (d) =>
          options.findIndex(
            (e) => String(e.id)?.toLowerCase?.() === String(d)?.toLowerCase?.()
          ) > -1
      )
    : options.find(
        (d) => String(d.id)?.toLowerCase?.() === String(value)?.toLowerCase?.()
      )?.id;

  const isCustomEmptyOption =
    useMemo(() => options.findIndex((d) => d.id === '') !== -1, [options]) ||
    undefined;
  return (
    <FormControl
      variant="outlined"
      size="small"
      style={style}
      fullWidth
      hiddenLabel
      sx={{ minWidth: 'fit-content', ...sx }}
    >
      <InputLabel
        variant="outlined"
        id={`label-${id}`}
        aria-label={label}
        shrink={isCustomEmptyOption}
      >
        {label}
      </InputLabel>
      <Select
        value={selectedValue ?? ''}
        multiple={multiple}
        onChange={(event: SelectChangeEvent) => onChange?.(event.target.value)}
        notched={isCustomEmptyOption}
        inputProps={{ 'aria-label': 'Without label', id: id }}
        labelId={`label-${id}`}
        id={`select-${id}`}
        label={label}
        MenuProps={{
          style: {
            maxHeight: '40rem',
          },
        }}
        displayEmpty={isCustomEmptyOption}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
